import { Component, OnInit } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UtilitiesService } from '../../../shared/_services/utilities.service';
import { QuestionUser, Question } from '../../../shared/models/question.model';
import { UserService } from '../../../shared/_services/user.service';

@Component({
  selector: 'app-lost-password',
  templateUrl: './lost-password.component.html',
  styleUrls: ['../login.component.css'],
  animations: [
    trigger('enterState', [
        state('void', style({
          opacity: 0.2,
          transform: 'translateX(-100%)'          
        })),
        transition(':enter',[
          animate(300, style({
            opacity: 1,
            transform: 'translateX(0)'
        }))
      ])
    ]) 
  ]
})
export class LostPasswordComponent implements OnInit {

  fdSendEmail: boolean = false;
  QuestionUser: QuestionUser;
  listQuestion: Question[];
  error: any;
  pregunta: string;
  respuesta: string;
  next: boolean = true;
  constructor(private router: Router, private QuestionService: UtilitiesService, private Userservice: UserService) { }

  ngOnInit() {
    this.QuestionService.getAllQuestions()
      .subscribe((respuesta: Question[]) => this.listQuestion = respuesta, err => this.error= err)
  }
  
  SendRecovery() {
    if (this.respuesta == this.QuestionUser.questionAnswer) {
      this.Userservice.setRandomPassword(this.QuestionUser.idUser)
        .subscribe((respuesta: any) => {
          this.fdSendEmail = true;
          this.error = undefined;
        }, err => this.error = err)
    } else {
      this.error = "La  respuesta a la pregunta no es válida."
    }
  }

  goBack(){
    this.router.navigate(['/login'])
  }

  cargarPregunta(nickname: string) {
    if (nickname != '') {
      this.QuestionService.getQuiestionbyName(nickname)
        .subscribe((res: QuestionUser) => {
          this.QuestionUser = res;
          this.pregunta = this.listQuestion.filter(u => u.idQuestion == this.QuestionUser.idQuestion)[0].question;
          this.error = undefined;
          this.next = false;
        }, err => this.error = err)
    } else {
      this.error = "Debe completar el campo."
      this.next = true;
    }
  }
}
